module.exports = __webpack_public_path__ + "img/pDaying.6152e797.png";